import React from 'react';
import { useChat } from '../../contexts/ChatContext';
import ChatTabs from './ChatTabs';
import ChatMessages from './ChatMessages';
import ChatControls from './ChatControls';
import './ChatInterface.css';

const ChatInterface = () => {
  const { 
    currentTab, 
//    isConnected, 
    connectionStatus, 
    error,
    changeTab,
  //  clearMessages,
    getTabCounts,
    TAB_TYPES
  } = useChat();

  const tabCounts = getTabCounts();

  return (
    <div className="chat-interface">
      {/* Header */}
      <div className="chat-header">
        <h2>Voice Assistant Chat</h2>
        <div className="connection-status">
          <span className={`status-indicator ${connectionStatus}`}>
            <span className={`status-dot ${connectionStatus}`}></span>
            {connectionStatus === 'connected' && 'Connected'}
            {connectionStatus === 'connecting' && 'Connecting...'}
            {connectionStatus === 'disconnected' && 'Disconnected'}
            {connectionStatus === 'error' && 'Error'}
          </span>
        </div>
      </div>

      {/* Error Display */}
      {error && (
        <div className="error-message">
          <span>{error}</span>
        </div>
      )}

      {/* Tabs */}
      <ChatTabs 
        currentTab={currentTab}
        tabCounts={tabCounts}
        onTabChange={changeTab}
        tabTypes={TAB_TYPES}
      />

      {/* Messages */}
      <ChatMessages />

      {/* Controls */}
      <ChatControls />
    </div>
  );
};

export default ChatInterface; 